import { React, useState, useRef, useEffect } from "react";
import "./servicescomp.css";
import hardware1 from "../../images/choice1.png";
import hardware2 from "../../images/choice2.png";
import hardware3 from "../../images/choice3.png";
import hardware4 from "../../images/choice4.png";
import hardware5 from "../../images/choice5.png";
import hardware6 from "../../images/choice6.png";
import hardware7 from "../../images/choice7.png";
import hardware8 from "../../images/choice8.png";
import hardware9 from "../../images/choice9.png";

const services = ["one", "two", "three"];
const delay = 7000;

export default function Servicescomp() {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === services.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);

  return (
    <div className="slideshow">
      <div
        className="slideshowSlider"
        style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
      >
        <div className="slide1" key={0}>
          <div className="holder">
            <div className="kwanza">
              <img src={hardware1} alt="" className="juu" />
              <div className="down">
                <h3>Car mechanical Services</h3>
                <div className="wordings">High quality Mechanical repairs</div>
              </div>
            </div>
            <div className="pili">
              <img src={hardware2} alt="" className="juu" />
              <div className="down">
                <h3>Car Electrical Services</h3>
                <div className="wordings">High quality electrical repairs</div>
              </div>
            </div>
            <div className="tatu">
              <img src={hardware3} alt="" className="juu" />
              <div className="down">
                <h3>Spray Painting</h3>
                <div className="wordings">Qigh quality speay painting</div>
              </div>
            </div>
          </div>
        </div>
        <div className="slide2" key={1}>
          <div className="holder">
            <div className="kwanza">
              <img src={hardware4} alt="" className="juu" />
              <div className="down">
                <h3>Pannel Beating</h3>
                <div className="wordings">We fix accidental damages</div>
              </div>
            </div>
            <div className="pili">
              <img src={hardware5} alt="" className="juu" />
              <div className="down">
                <h3>Buffing</h3>
                <div className="wordings">Make your car to shine</div>
              </div>
            </div>
            <div className="tatu">
              <img src={hardware6} alt="" className="juu" />
              <div className="down">
                <h3>Car Interior Decor</h3>
                <div className="wordings">mordern interior decorations</div>
              </div>
            </div>
          </div>
        </div>
        <div className="slide3" key={3}>
          <div className="holder">
            <div className="kwanza">
              <img src={hardware7} alt="" className="juu" />
              <div className="down">
                <h3>Welding and Fabrication</h3>
                <div className="wordings">Good fabrication ad welding</div>
              </div>
            </div>
            <div className="pili">
              <img src={hardware8} alt="" className="juu" />
              <div className="down">
                <h3>Car Fitting</h3>
                <div className="wordings">
                  <p>We have experts and tyre </p>
                  <p>technicians can fit</p>
                  <p>tyres for all car</p>
                </div>
              </div>
            </div>
            <div className="tatu">
              <img src={hardware9} alt="" className="juu" />
              <div className="down">
                <h3>Selling New and Used Cars</h3>
                <div className="wordings">Get the best deals</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="slideshowDots">
        {services.map((_, idx) => (
          <div
            key={idx}
            className={`slideshowDot${index === idx ? " active" : ""}`}
            onClick={() => {
              setIndex(idx);
            }}
          ></div>
        ))}
      </div>
    </div>
  );
}
